<template>
  <div id="app">
    <router-view/>
    <Tabbar v-if="$route.meta.showMenu" style="align-self: center"></Tabbar>
  </div>
</template>

<script>
import Tabbar from "./controls/Tabbar";

export default {
  name: 'App',
  components: {
    Tabbar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 10px;
}
</style>